import { isNil } from 'lodash';

export type AutoReplySettingsForm = {
  draftingInstructions?: string | null;
  whenToRespond?: string[] | null;
  ccRecipients?: string[] | null;
  bccRecipients?: string[] | null;
  draftTemplateType?: string | null;
  actionDefinitionId?: string | null;
  sendDelaySeconds?: number | null;
};

export const getDefaultFormValues = (
  autoReplySettings?: AutoReplySettingsForm | null
) => {
  if (!isNil(autoReplySettings)) {
    return autoReplySettings;
  }

  return {
    draftingInstructions: undefined,
    whenToRespond: undefined,
    ccRecipients: [],
    bccRecipients: [],
    draftTemplateType: undefined,
    actionDefinitionId: undefined,
    sendDelaySeconds: undefined,
  };
};
